import React from "react";

function SaveSettingsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1829_1251)">
        <path
          d="M18.378 2.1736C17.9145 1.81226 17.3484 1.6071 16.761 1.5876C15.1747 1.52721 13.5874 1.49804 12 1.5001C8.318 1.5001 5.7425 1.6386 4.1285 1.7696C2.851 1.8736 1.8735 2.8511 1.7695 4.1286C1.6385 5.7426 1.5 8.3181 1.5 12.0001C1.5 15.6821 1.6385 18.2576 1.7695 19.8716C1.8735 21.1491 2.851 22.1266 4.1285 22.2306C5.7425 22.3616 8.318 22.5001 12 22.5001C15.682 22.5001 18.2575 22.3616 19.8715 22.2306C21.149 22.1266 22.1265 21.1491 22.2305 19.8716C22.3615 18.2576 22.5 15.6821 22.5 12.0001C22.5 10.1356 22.4645 8.5551 22.4125 7.2391C22.3929 6.65165 22.1875 6.08555 21.826 5.6221C21.396 5.0771 20.832 4.4081 20.2115 3.7881C19.5915 3.1681 18.9225 2.6041 18.378 2.1736Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6465 1.55029C15.6635 1.90279 15.6745 2.32229 15.6745 2.81329C15.6754 3.26133 15.6647 3.70931 15.6425 4.15679C15.5985 5.00379 14.9365 5.62579 14.089 5.66179C13.5575 5.68379 12.866 5.70079 11.9995 5.70079C11.133 5.70079 10.442 5.68379 9.9105 5.66129C9.063 5.62629 8.401 5.00379 8.357 4.15679C8.33459 3.70931 8.32376 3.26133 8.3245 2.81329C8.3245 2.32229 8.336 1.90279 8.353 1.55029M18.181 22.3453C18.244 21.3388 18.2995 19.9198 18.2995 18.0378C18.2995 15.8028 18.2215 14.2203 18.1445 13.2068C18.0805 12.3548 17.432 11.7003 16.5805 11.6318C15.6055 11.5538 14.104 11.4753 11.9995 11.4753C9.895 11.4753 8.3935 11.5538 7.419 11.6323C6.567 11.7003 5.919 12.3548 5.8545 13.2073C5.778 14.2203 5.6995 15.8028 5.6995 18.0378C5.6995 19.9198 5.755 21.3388 5.8185 22.3453M9.5 15.5003H14.5M9.5 18.5003H12.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1829_1251">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SaveSettingsIcon;
